var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77816 0.229417C9.63646 0.0873971 9.44408 0.00758438 9.24346 0.00758438C9.04284 0.00758438 8.85046 0.0873971 8.70876 0.229417L5 3.9306L1.29124 0.221832C1.14954 0.0798127 0.957162 0 0.756541 0C0.555921 0 0.363543 0.0798127 0.221843 0.221832C-0.0739477 0.517623 -0.0739477 0.99544 0.221843 1.29123L3.9306 4.99999L0.221843 8.70876C-0.0739477 9.00455 -0.0739477 9.48237 0.221843 9.77816C0.517634 10.0739 0.995449 10.0739 1.29124 9.77816L5 6.06939L8.70876 9.77816C9.00455 10.0739 9.48237 10.0739 9.77816 9.77816C10.0739 9.48237 10.0739 9.00455 9.77816 8.70876L6.0694 4.99999L9.77816 1.29123C10.0664 1.00302 10.0664 0.517623 9.77816 0.229417Z",
    fill: "#6D7D8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.318471fd27e696a874de4a5d549f93bd.svg";
export { ForwardRef as ReactComponent };